import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

function handleRemoveButton ({ event, onRemove }) {
  event.preventDefault()
  event.stopPropagation()
  onRemove(event)
}

export default function SlotElement ({ matchedCartGame, onRemove, children, ...props }) {
  return (
    React.createElement(
      matchedCartGame ? 'div' : 'button',
      props,
      <Fragment>
        {matchedCartGame && (
          <button className="remove_game_button" onClick={event => { handleRemoveButton({ event, onRemove }) }}>
          </button>
        )}
        {children}
      </Fragment>
    )
  )
}

SlotElement.propTypes = {
  matchedCartGame: PropTypes.object,
  onRemove: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
}
